// @flow
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CreateAction = styled(Link)`
    align-items: center;
    border: dashed 1px ${p => p.theme.secondaryMedium};
    border-radius: 0.5em;
    cursor: pointer;
    display: flex;
    height: 2.4em;
    justify-content: center;
    padding: 0.2em;
`;

export const PlusContainer = styled.div`
    height: 1.8em;
    width: 3em;

    & > svg > g {
        fill: ${p => p.theme.mainBrandColor};
    }
`;

export const NumberActions = styled.div`
    align-items: center;
    background-color: ${p => p.theme.secondaryLight};
    border-radius: 0.5em;
    display: flex;
    height: 1.8em;
    justify-content: center;
    margin: 1em 0;
`;

export const NumberText = styled.span`margin-left: 0.5em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/styles.js